export default {
	computed: {
		isNuxtClient() {
			return process.client;
		},
	},
};
